"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NAMESPACE = void 0;

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _routes = _interopRequireDefault(require("./routes"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _epics = _interopRequireDefault(require("./epics"));

var NAMESPACE = 'ads';
exports.NAMESPACE = NAMESPACE;
var _default = {
  route: _UrlPathParams.ADS,
  routes: _routes.default,
  reducer: _reducers.default,
  rootEpic: _epics.default,
  dsn: 'https://2077c22e3d41968d3239e59785277833@exceptions.hubspot.com/43514',
  shouldModuleRender: function shouldModuleRender(_ref) {
    var scopes = _ref.scopes;
    return (0, _scopeChecks.matchesSomeScopes)(['ads-pro', 'ads-free'])({
      scopes: scopes
    }) && (0, _scopeChecks.matchesSomeScopes)(['ads-read', 'ads-write'])({
      scopes: scopes
    });
  }
};
exports.default = _default;